import { render } from "./Promotions.vue?vue&type=template&id=056fc21e&scoped=true"
import script from "./Promotions.vue?vue&type=script&lang=js"
export * from "./Promotions.vue?vue&type=script&lang=js"

import "./Promotions.vue?vue&type=style&index=0&id=056fc21e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-056fc21e"]])

export default __exports__